module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/december-44ab63ebb1db246d2790b8e49ac82e20.png";